const initialState = {
  shop_address: {},
};

const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_SHOP_ADDRESS_REDUCER': {
      return initialState;
    }
    case 'SET_SHOP_ADDRESS': {
      return { ...state, shop_address: action.data };
    }

    default:
      return state;
  }
};

export default shopReducer;
